import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer>
      <div className="footer">
        <p>Copyrights &copy; 2025 My website. All Rights Reserved.</p>
        <p>Powered by My website.</p>
      </div>
    </footer>
  );
};

export default Footer;
